export const FETCH_SESSIONS = 'FETCH_SESSIONS';
